import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-user-table-toolbar": "base"
}
const _hoisted_8 = {
  key: 0,
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_user"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "btn-group dropstart" }
const _hoisted_14 = {
  key: 0,
  class: "btn btn-sm btn-light dropdown-toggle",
  type: "button",
  id: "actions",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_15 = {
  key: 1,
  class: "dropdown-menu",
  "aria-labelledby": "actions"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!
  const _component_EditUserModal = _resolveComponent("EditUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Users"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.checkedUsers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                      ]),
                      _hoisted_10
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-name": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.name), 1)
              ]),
              "cell-email": _withCtx(({ row: user }) => [
                _createElementVNode("a", {
                  href: "#",
                  class: "text-gray-600 text-hover-primary mb-1",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_edit_user",
                  onClick: ($event: any) => (_ctx.selectUser(user))
                }, _toDisplayString(user.email), 9, _hoisted_12)
              ]),
              "cell-role": _withCtx(({ row: user }) => [
                _createTextVNode(_toDisplayString(user.role), 1)
              ]),
              "cell-actions": _withCtx(({ row: user }) => [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_14, " Actions "))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_edit_user",
                            onClick: ($event: any) => (_ctx.selectUser(user))
                          }, "Edit", 8, _hoisted_16)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.deleteUser(user.ID))
                          }, "Delete", 8, _hoisted_17)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_AddUserModal, { reloadData: _ctx.fetchData }, null, 8, ["reloadData"]),
    _createVNode(_component_EditUserModal, {
      user: _ctx.selectedUser,
      reloadData: _ctx.fetchData
    }, null, 8, ["user", "reloadData"])
  ], 64))
}